import parseJsonSafe from "../utils/parseJsonSafe";
import SubscriptionPlanCard from "./SubscriptionPlanCard";
import React from "react";

const SubscriptionPlansCarousel = ({
  plans = [],
  onSubmit,
  selectedPlan,
  setSelectedPlan,
  loading,
}) => {
  return (
    <div className="flex pt-9 max-w-[97vw] overflow-x-scroll">
      {plans.map((i, idx) => {
        const {
          originalPrice,
          features = [],
          otherFeatures = [],
          mostPopular = false,
        } = parseJsonSafe(i.benefits);

        return (
          <div key={idx} className="pl-4 last:pr-4 flex pb-4">
            <SubscriptionPlanCard
              i={i}
              features={features}
              otherFeatures={otherFeatures}
              mostPopular={mostPopular}
              onSubmit={onSubmit}
              originalPrice={originalPrice}
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              loading={loading}
            />
          </div>
        );
      })}
    </div>
  );
};

export default SubscriptionPlansCarousel;
